<vl-chips [iconLeft]="iconLeft()" [stopPropagation]="false" cursor="default"
          [state]="state()">{{ etatLibelle() }}
</vl-chips>
